import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const AUTH_METHOD_KEY = 'method'


export type AuthStates =
  'GOV_INICIADO' | 'GOV_FINALIZADO' | 'PING_INICIADO' | 'PING_FINALIZADO'


@Injectable({
  providedIn: 'root',
})
export class AuthStateService {

  public CurrentAuthorizationState: BehaviorSubject<AuthStates | null> = new BehaviorSubject<AuthStates | null>(null)

  setAuthMethod(method: 'ping' | 'gov'): void {
    localStorage.setItem(AUTH_METHOD_KEY, method)
  }

  getAuthMethod(): 'ping' | 'gov' | null {
    var authMethod = localStorage.getItem(AUTH_METHOD_KEY)

    switch (authMethod) {
      case 'ping': return 'ping';
      case 'gov': return 'gov';
      default: return null;
    }
  }

  clearAuthMethod(): void {
    localStorage.removeItem(AUTH_METHOD_KEY);
  }
}
